import React from 'react';
import { Paper } from '@mui/material';

import InsertionPanel from './InsertionPanel';

export default function AddItemPanel() {
  return (
    <Paper
      elevation={0}
      sx={{
        whiteSpace: 'nowrap',
        position: 'absolute',
        top: 0,
        bottom: 0,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <InsertionPanel />
    </Paper>
  );
}
